import * as React from "react";
const SvgMinimalist = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M16 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" fill="currentColor" />
    <path
      d="M22.483 5.092a.75.75 0 0 1-.574.891l-.409.089V20.25A1.75 1.75 0 0 1 19.75 22H5.25a1.75 1.75 0 0 1-1.75-1.75V9.963l-.091.02a.75.75 0 1 1-.317-1.466l2.408-.52V5.75a.75.75 0 0 1 1.5 0v1.922l1-.216V6.75a.75.75 0 0 1 1.5 0v.382l12.092-2.615a.75.75 0 0 1 .891.575ZM5 9.639V20.25c0 .138.112.25.25.25H6.5v-6.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v6.75h.51a3.25 3.25 0 0 1 6.48 0h.26a.25.25 0 0 0 .25-.25V6.396L5 9.639Zm6 4.861H8v6h3v-6Zm5.25 4.5a1.75 1.75 0 0 0-1.732 1.5h3.464A1.75 1.75 0 0 0 16.25 19Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMinimalist;
